import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconSpeechbubble = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M19 4c1.6569 0 3 1.3431 3 3v7c0 1.6569-1.3431 3-3 3h-6.5895l-3.9968 4H6v-4H5c-1.6568 0-3-1.3431-3-3V7c0-1.6569 1.3432-3 3-3h14zm1 3c0-.5523-.4477-1-1-1H5c-.5523 0-1 .4477-1 1v7c0 .5523.4477 1 1 1h3v3.5845L11.5817 15H19c.5523 0 1-.4477 1-1V7z",
		fill: "#111"
	})
});
export default SvgIconSpeechbubble;
